import "./DialogComp.css";
import { defineComponent as t, resolveComponent as n, openBlock as s, createBlock as r, withCtx as a, createElementVNode as p, renderSlot as c } from "vue";
import { OverlayComp as i } from "./OverlayComp.js";
import { _ as d } from "./_plugin-vue_export-helper.dad06003.js";
const m = t({
  name: "dialog-comp",
  components: {
    OverlayComp: i
  },
  props: {
    open: {
      type: Boolean,
      required: !0
    }
  },
  data() {
    return {
      activeDescendants: []
    };
  },
  methods: {
    close() {
      this.$emit("update:open", !1);
    },
    keyPress(e) {
      this.open && e.key === "Escape" && this.activeDescendants.length === 0 && this.close();
    }
  },
  mounted() {
    document.addEventListener("keyup", this.keyPress);
  },
  beforeUnmount() {
    document.removeEventListener("keyup", this.keyPress);
  }
});
const l = {
  ref: "dialogBackdrop",
  class: "dialog-backdrop"
};
function _(e, u, f, v, y, h) {
  const o = n("overlay-comp");
  return s(), r(o, { active: e.open }, {
    default: a(() => [
      p("div", l, [
        c(e.$slots, "default")
      ], 512)
    ]),
    _: 3
  }, 8, ["active"]);
}
const B = /* @__PURE__ */ d(m, [["render", _]]);
export {
  B as DialogComp
};
//# sourceMappingURL=DialogComp.js.map
